package team.platforma.multiplatform_material_extension.calendar.calendar_period.dialog

import androidx.compose.foundation.Indication
import androidx.compose.foundation.LocalIndication
import androidx.compose.foundation.clickable
import androidx.compose.foundation.indication
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material.ripple.RippleAlpha
import androidx.compose.material.ripple.rememberRipple
import androidx.compose.material3.ButtonColors
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.ripple
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.NoInspectorInfo
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import kotlinx.datetime.Clock
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.plus
import kotlinx.datetime.todayIn
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.mel_select_date_period
import materialextension.multiplatform_material_extension.generated.resources.mel_select_year
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource
import team.platforma.multiplatform_material_extension.calendar.calendar_period.core_ui.CalendarPeriodImpl
import team.platforma.multiplatform_material_extension.calendar.properties.CalendarViewProperties
import team.platforma.multiplatform_material_extension.calendar.properties.DatePikerProperties
import team.platforma.multiplatform_material_extension.calendar.style.CalendarViewStyle
import team.platforma.multiplatform_material_extension.calendar.utils.CalendarRange
import team.platforma.multiplatform_material_extension.calendar.utils.setStandardCalendarRange
import team.platforma.multiplatform_material_extension.ui.dialog.CommonDialog
import team.platforma.multiplatform_material_extension.ui.dialog.style.CommonDialogStyle
import team.platforma.multiplatform_material_extension.util.gestures.horizontalGestures
import team.platforma.multiplatform_material_extension.util.gestures.rememberHorizontalGestures

@Composable
fun PeriodDatePiker(
    startDate: LocalDate? = null,
    endDate: LocalDate? = null,
    title: StringResource,
    calendarRange: CalendarRange? = null,
//    onMonthSelected: (List<LocalDate>) -> Unit = {},
    onDismiss: () -> Unit,
    properties: DatePikerProperties? = null,
    onPeriodSelected: (firstDate: LocalDate, secondDate: LocalDate) -> Unit,
) {

    val currentDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
    val initializeCalendarRange = calendarRange ?: setStandardCalendarRange(currentDate)

    val initStartDate: LocalDate = startDate?.let { customStartDate ->
        if (customStartDate in initializeCalendarRange.max..initializeCalendarRange.min) {
            customStartDate
        } else {
            currentDate
        }
    } ?: if (currentDate in initializeCalendarRange.max..initializeCalendarRange.min) {
        currentDate
    } else {
        currentDate
    }

    val initEndDate: LocalDate = endDate?.let { customStartDate ->
        if (customStartDate in initializeCalendarRange.max..initializeCalendarRange.min) {
            customStartDate
        } else {
            currentDate.plus(DatePeriod(days = 1))
        }
    } ?: if (currentDate in initializeCalendarRange.max..initializeCalendarRange.min) {
        currentDate.plus(DatePeriod(days = 1))
    } else {
        currentDate.plus(DatePeriod(days = 1))
    }

    val mStartDate by remember { mutableStateOf(initStartDate) }
    val mEndDate by remember { mutableStateOf(initEndDate) }

    var mPeriodStartDate by remember { mutableStateOf<LocalDate?>(null) }
    var mPeriodEndDate by remember { mutableStateOf<LocalDate?>(null) }

    var periodSetup by remember { mutableStateOf(false) }

    LaunchedEffect(mPeriodStartDate, mPeriodEndDate) {
        periodSetup = mPeriodStartDate != null && mPeriodEndDate != null
    }

    var clearPeriod by remember { mutableStateOf(false) }

    val dialogProperties: DatePikerProperties = properties ?: DatePikerProperties()
    val horizontalGestures =
        if (dialogProperties.animateUserScroll) rememberHorizontalGestures() else null

    CommonDialog(
        onDismiss = { onDismiss() },
        title = {
            Text(
                text = stringResource(title),
                modifier = Modifier.padding(vertical = 8.dp),
                fontWeight = FontWeight.Medium,
                color = CommonDialogStyle.dialogStyle().titleColor
            )
        },
        customStyle = CalendarViewStyle.pikerStyle().dialogStyle,
        properties = DialogProperties(
            dismissOnBackPress = dialogProperties.dismissOnBackPress,
            dismissOnClickOutside = dialogProperties.dismissOnClickOutside,
            usePlatformDefaultWidth = false
        )
    ) {
        LazyColumn {
            item {
                CalendarPeriodImpl(
                    modifier = Modifier.horizontalGestures(horizontalGestures),
                    initFirstDate = mStartDate,
                    initSecondDate = mEndDate,
                    properties = CalendarViewProperties(
                        animateClickChangeButtonMonth = dialogProperties.animateClickChangeButtonMonth,
                    ),
                    calendarBadges = null,
                    calendarRange = initializeCalendarRange,
                    horizontalGestures = horizontalGestures,
                    onMonthYearChange = {

                    },
                    onPeriodSelected = { firstDate, secondDate ->
                        mPeriodStartDate = firstDate
                        mPeriodEndDate = secondDate
                    },
                    customStyle = CalendarViewStyle.pikerStyle().dialogStyle,
                    clearPeriod = clearPeriod,
                    onPeriodCleared = {
                        periodSetup = false
                        clearPeriod = false
                    },
                    showClearButton = false
                )
            }
            item {
                Row(
                    modifier = Modifier.fillMaxWidth()
                        .padding(start = 8.dp, end = 8.dp, bottom = 8.dp),
                    horizontalArrangement = Arrangement.Start
                ) {
                    TextButton(
                        enabled = periodSetup,
                        onClick = {
                            clearPeriod = true
                        }
                    ) {
                        Text(
                            text = stringResource(CalendarViewStyle.pikerStyle().neutralButton.label),
                            color = if (periodSetup) CalendarViewStyle.pikerStyle().neutralButton.color else CalendarViewStyle.pikerStyle().disableButton.color,
                            style = CalendarViewStyle.pikerStyle().neutralButton.style
                        )
                    }
                    Spacer(
                        modifier = Modifier.weight(1f)
                    )
                    TextButton(onClick = { onDismiss() }) {
                        Text(
                            text = stringResource(CalendarViewStyle.pikerStyle().negativeButton.label),
                            color = CalendarViewStyle.pikerStyle().negativeButton.color,
                            style = CalendarViewStyle.pikerStyle().negativeButton.style
                        )
                    }

                    TextButton(
                        enabled = periodSetup,
                        onClick = {
                            if (mPeriodStartDate != null && mPeriodEndDate != null) {
                                onPeriodSelected(
                                    mPeriodStartDate!!,
                                    mPeriodEndDate!!
                                )
                            }
                            onDismiss()
                        }
                    ) {
                        Text(
                            text = stringResource(CalendarViewStyle.pikerStyle().positiveButton.label),
                            color = if (periodSetup) CalendarViewStyle.pikerStyle().positiveButton.color else CalendarViewStyle.pikerStyle().disableButton.color,
                            style = if (periodSetup) CalendarViewStyle.pikerStyle().positiveButton.style else CalendarViewStyle.pikerStyle().disableButton.style
                        )
                    }
                }
            }
        }
    }
}